import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/form.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/error.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/bg/9.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/icons/email.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/icons/phone.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/icons/telegram.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/icons/whatsapp.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/footers/Copyright.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/CategoriesMenu.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/headers/HeaderAccountSelector.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderCart.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/headers/HeaderCartShow.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderSearch.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/HeaderWishlist.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/headers/Logo.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/headers/MobileMenuWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/contacts/ContactPrimary.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/wrappers/ClientProviders.js");
